import type { NestedTag, TreeTag } from '../../types';

export const assignLevels = (nodes: NestedTag[], currentLevel: number) => {
  for (const node of nodes) {
    node.level = currentLevel;

    if (node.children.length > 0) {
      assignLevels(node.children, currentLevel + 1);
    }
  }
};

export const createPrevTreeTagMap = (prevTreeTags: TreeTag[]) => {
  const map = new Map<string, TreeTag>();

  for (const tag of prevTreeTags) {
    map.set(tag.id, tag);
  }

  return map;
};

export const sortFn = (a: NestedTag, b: NestedTag) => {
  if (a.createdAt > b.createdAt) return -1;
  if (a.createdAt < b.createdAt) return 1;

  return a.name.localeCompare(b.name);
};
